import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_REJECT_ACCOUNT_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_REJECT_ACCOUNT_API_ID';

const rejectAccount = createApiCall(
  FETCH_INVESTCORE_REJECT_ACCOUNT_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/users/${id}/reject`,
    method: 'PATCH',
    body: payload,
    notify: true,
    isReload: true,
  })
);

export default rejectAccount;
